import { useEffect, useState } from "react";
import Sidebar from "../components/Sidebar";
import Header from "../components/Header";

export default function Dashboard() {
  const token = localStorage.getItem("adminToken");

  const [data, setData] = useState({
    totalUsers: 0,
    todayUsers: 0,
    totalDeposit: 0,
    todayDeposit: 0,
    totalInvestment: 0,
    todayInvestment: 0,
  });

  useEffect(() => {
    loadDashboard();
  }, []);

  async function loadDashboard() {
    const res = await fetch("/api/admin/dashboard", {
      headers: { Authorization: "Bearer " + token },
    });

    const json = await res.json();

    if (json.success) {
      setData(json);
    }
  }

  function Card({ title, value, color }) {
    return (
      <div
        style={{
          background: color,
          padding: 20,
          borderRadius: 12,
          color: "#fff",
          minHeight: 120,
        }}
      >
        <h3>{title}</h3>
        <h1>{value}</h1>
      </div>
    );
  }

  return (
    <div style={{ display: "flex", minHeight: "100vh", background: "#f3f4f6" }}>
      <Sidebar />

      <div style={{ flex: 1 }}>
        <Header />

        <div style={{ padding: 25 }}>
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(3,1fr)",
              gap: 20,
            }}
          >
            <Card title="Total Users" value={data.totalUsers} color="#2563eb" />
            <Card title="Today's Users" value={data.todayUsers} color="#16a34a" />
            <Card title="Total Deposit" value={`${data.totalDeposit} USDT`} color="#9333ea" />
            <Card title="Today's Deposit" value={`${data.todayDeposit} USDT`} color="#ea580c" />
            <Card title="Total Investment" value={`${data.totalInvestment} USDT`} color="#0891b2" />
            <Card title="Today's Investment" value={`${data.todayInvestment} USDT`} color="#dc2626" />
          </div>
        </div>
      </div>
    </div>
  );
}
